import { IoChevronDown } from "react-icons/io5";

interface LoadMoreButtonProps {
  onClick: () => void;
  loading?: boolean;
  label?: string;
}

function LoadMoreButton({
  onClick,
  loading = false,
  label = "Load more",
}: LoadMoreButtonProps) {
  return (
    <div className={ClassName.container}>
      <button
        type="button"
        className={ClassName.button}
        onClick={onClick}
        disabled={loading}
      >
        {loading ? (
          <div className="primaryLoader" />
        ) : (
          <IoChevronDown size={17} />
        )}
        <span>{loading ? "Loading..." : label}</span>
      </button>
    </div>
  );
}

export default LoadMoreButton;

const ClassName = {
  container: "flex w-full items-center justify-center py-4",
  button:
    "inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-4 text-sm font-semibold text-primaryText transition-colors hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60",
};
